import { useEffect, useState } from "react";

import {
  getPlatformSettings,
  fetchPlatformSettings,
} from "../lib/platformSettings";

export default function usePlatformSettings() {
  const [settings, setSettings] = useState(
    () => getPlatformSettings() || {}
  );

  const [settingsLoaded, setSettingsLoaded] = useState(false);
  const [settingsError, setSettingsError] = useState(null);

  useEffect(() => {
    let isActive = true;

    const loadSettings = async () => {
      try {
        setSettingsError(null);

        const freshSettings = await fetchPlatformSettings();

        if (!isActive) return;

        setSettings(freshSettings || {});
      } catch (error) {
        if (!isActive) return;

        console.error("Error loading Platform Settings:", error);
        setSettingsError(error);
      } finally {
        if (isActive) {
          setSettingsLoaded(true);
        }
      }
    };

    loadSettings();

    return () => {
      isActive = false;
    };
  }, []);

  return {
    settings,
    settingsLoaded,
    settingsError,
  };
}